
import React from 'react';
import { Navigate } from 'react-router-dom';
import { DEFAULT_DASHBOARD_PATH } from '@/lib/uiSwitch';

const Index = () => {
  // Redirect to the dashboard 
  return <Navigate to={DEFAULT_DASHBOARD_PATH} replace />;
};

export default Index;
